import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


import { NavigationService } from '../services/navigation.service'

import { environment } from '../../environments/environment';
import {ThemePalette} from '@angular/material/core';
import { AuthenticationService } from '../services/authentication.service'
import { MenuService } from '../services/menu.service'
import { AuthWebService } from 'app/services/authweb.service';
import { CarrierService } from 'app/services/carrier.service';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements OnInit {
  links = ['First', 'Second', 'Third'];
  activeLink = this.links[0];
  background: ThemePalette = undefined;
  public ParentItems: any = [];
  public ChildItems: any = [];
  public hasAdmin: boolean;

  private subMenuCache: any = {};
  //public authentication;
  public loggedInUser;
  public UserData: any = [];
  user: any = {};
  isLoading: boolean = false;
  selectedItem



  constructor(public authentication: AuthWebService,private carrierService: CarrierService
    ,private toaster: ToastrService,private toastService:ToastNotificationService,
    private router: Router) {
      console.log(this.authentication.userData)

    // this.authentication = auth;
    this.user = (this.authentication.userData) ? this.authentication.userData.User : null;

    this.UserData = environment.authWebApi.userData
    if (this.UserData != null) {
      

      this.sortMenu(this.UserData)
    }
  }

  ngOnInit() {
  }
  checkCarriers(){
    this.isLoading = true;

    this.carrierService.listCarrierAccountsByUserId(this.user.Id,5,1).subscribe((result:any) => {
      console.log(result);
      
      if (result.length > 1) {
        this.toastService.error('Please use menu to the right of relevant account line.','')
        setTimeout(() => {
          this.toaster.clear();
          clearTimeout();
        }, 8000);
      }
      this.isLoading = false; 
    }, error => {
      
      this.isLoading = false;

    })
  }
  menuClicked(sm){
    console.log("testing")
    console.log(sm)
    if(sm.Code === "CVM" && this.authentication.userData.Roles.find(x=>x.Code === "GUEST")){
      this.router.navigateByUrl('/carrier/vehicle/list');
    }
    if(sm.Code === "LISTAPP" && this.authentication.userData.Roles.find(x=>x.Code === "GUEST")){
      this.checkCarriers();
    }
    if(sm.Code === "LISTAPP" && this.authentication.userData.Roles.find(x=>x.Code === "ADMIN")){
      this.router.navigateByUrl('/maintain-view-permit');
      }
      if(sm.Code === "VCA" && this.authentication.userData.Roles.find(x=>x.Code === "GUEST")){
        //this.router.navigateByUrl('/carrier/accounts/'+sm.code);
        }
    
    

  }
  hasChildren(parent) {

    if (this.ChildItems.some(x => x.MainMenuID === parent.ID))
      return true
  }


  sortMenu(data) {
    

    if (data.MainMenus.length > 0) {

      let count = data.MainMenus.length;

      for (let i = 0; i < count; i++) {

        this.ParentItems.push(data.MainMenus[i])
      }

      let Ccount = data.SubMenus.length;

      for (let i = 0; i < Ccount; i++) {

        if (data.SubMenus[i].MenuItemYN == true) {
         if(data.SubMenus[i]["ID"] == 20071)
         {
           data.SubMenus[i]["ScreenName"] = "carrier/compliance/list";
         }
          this.ChildItems.push(data.SubMenus[i])
        }
      }

    }

  }


  subMenus(mainMenu) {

    // data.forEach(element => {
    //   if(element.CODE == 'ADMIN'){
    //     this.hasAdmin = true;
    //   }
    // });


    if (!this.hasAdmin) {
      if (mainMenu.Code == "ADMIN") {
        this.hasAdmin = true;
      }
    }



    if (typeof this.subMenuCache[mainMenu.ID] !== 'undefined') {
      return this.subMenuCache[mainMenu.ID];
    }

    if (this.authentication.userData && this.authentication.userData.SubMenus) {
      return this.subMenuCache[mainMenu.ID] = this.authentication.userData.SubMenus.filter((sm) => sm.MenuItemYN && sm.MainMenuID === mainMenu.ID);
    } else {
      return this.subMenuCache[mainMenu.ID] = [];
    }
  }

  pathFromScreenName(screenName: string) {
    
    let leftSideOfQuestionMark = (screenName + '').split('?', 2)[0];
    if(leftSideOfQuestionMark.indexOf('accounts')>0){
      leftSideOfQuestionMark=leftSideOfQuestionMark+"/VCA"
    }
    
    return leftSideOfQuestionMark;
  }

  queryParamsFromScreenName(screenName: string) {

    let result = {};
    let rightSideOfQuestionMark = (screenName + '').split('?', 2)[1];
    let parameters = (rightSideOfQuestionMark + '').split('&');

    for (let parameter of parameters) {
      let tokens = parameter.split('=', 2);
      result[tokens[0]] = tokens[1];
    }

    return result;
  }

  navAuthWeb() {
    const url = environment.authWebApi.client;
    window.open(url);
  }

  navSharePoint(){
    const url = this.UserData.SubMenus.find(p=>p.Code=='BO_SP').ScreenName;
    window.open(url);
  }
  navWFDashboard(){
    const url = this.UserData.SubMenus.find(p=>p.Code=='BO_WF').ScreenName;
    window.open(url);
  }

  subReport(){
    const url = this.UserData.SubMenus.find(p=>p.Code=='R').ScreenName;
    window.open(url);
  }
  subPowerBI(){
    const url = this.UserData.SubMenus.find(p=>p.Code=='BI').ScreenName;
    window.open(url);
  }
  clickClass(info){
    this.selectedItem = info;
  }
  
}
